var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-09-05
 * @brief EHP 메시지 관리 개발
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../../recoil/userState";
import { loadingBoxState } from "../../../../recoil/menuState";
import { langState } from '../../../../recoil/langState';
// utils
import clog from "../../../../utils/logUtils";
import * as CONST from "../../../../utils/Const";
import * as CUTIL from "../../../../utils/commUtils";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
//component
import EhpPagination from "../../../common/pagination/EhpPagination";
/**
 * @brief EHP 메시지 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function ErrorMsgList(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    const [langs, setRecoilLangs] = useRecoilState(langState); // recoil langState
    //props
    const isMobile = props.isMobile;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    const setParentPopWin = props.setPopWin;
    //화면 이동
    const navigate = useNavigate();
    //
    const [messageList, setMessageList] = useState([]);
    const defaultPageInfo = { "size": 10, "totalElements": 0, "totalPages": 0, "number": 0, "psize": 10 };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    const [codeParam, setCodeParam] = useState("");
    let appPath = "";
    appPath = 'page=' + pageInfo.number + '&size=' + pageInfo.size;
    if (codeParam.length > 0) {
        appPath = appPath + "&menuCode=" + codeParam;
    }
    const [listReload, setListReload] = useState(false);
    const [errorList, setErrorList] = useState([]);
    //{menuCode, menuName, errList : {}}
    //[{"field":"menuName","msg":"필수 항목입니다."}]
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/message/errormessages?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: selTree + appPath + listReload
        //watch: selTree.company.companyId+selTree.reload
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
        if (ERR_URL.length > 0) {
            setRecoilIsLoadingBox(false);
            navigate(ERR_URL);
        }
        if (retData) {
            setRecoilIsLoadingBox(false);
            //clog("IN CHECK MESSAGE LIST : RES : " + JSON.stringify(retData));
            if (retData.codeNum == CONST.API_200) {
                setListReload(false); // list reload
                setMessageList(retData.body);
                setPageInfo(Object.assign(Object.assign({}, retData.data.page), { psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT })); //5, 10
            }
        }
    }, [selTree, retData]);
    //////////////////
    function handleListReload(val, page) {
        if (page > -1)
            handleCurPage(page);
        setListReload(val);
    }
    useEffect(() => {
        setParentPopWin("pop-message-add", React.createElement(PopupErrorMessageInsert, { htmlHeader: React.createElement("h1", null, "\uC5D0\uB7EC \uBA54\uC138\uC9C0"), listReload: listReload, setListReload: handleListReload }));
    }, [listReload]);
    function onClickInsertErrorMessage(e) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-message-add");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "553");
        setParentPopWin("pop-message-add", React.createElement(PopupErrorMessageInsert, { htmlHeader: React.createElement("h1", null, "\uC5D0\uB7EC \uBA54\uC138\uC9C0"), listReload: listReload, setListReload: handleListReload }));
        CUTIL.jsopen_Popup(e);
    }
    function onClickViewErrorMessage(e, message) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-message");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "557");
        setParentPopWin("pop-message", React.createElement(PopupErrorMessageView, { htmlHeader: React.createElement("h1", null, "\uC5D0\uB7EC \uBA54\uC138\uC9C0"), errorMessage: message, listReload: listReload, setListReload: handleListReload, setPopWin: props.setPopWin }));
        CUTIL.jsopen_Popup(e);
    }
    function onClickDeleteErrorMessage(e, message) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-delete");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "200");
        setParentPopWin("pop-delete", React.createElement(PopupErrorMessageDelete, { htmlHeader: React.createElement("h1", null, "\uC0AD\uC81C"), errorMessage: message, listReload: listReload, setListReload: handleListReload }));
        CUTIL.jsopen_Popup(e);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__right_content workplace__info workplace__main info__input newtype" },
            React.createElement("div", { className: "page-top" },
                React.createElement("h2", null, "\uC5D0\uB7EC \uBA54\uC138\uC9C0")),
            React.createElement("div", { className: "tbl__top mb-16" },
                React.createElement("div", { className: "right" },
                    React.createElement("button", { type: "button", className: "bg-gray js-open", "data-pop": "pop-message-add", 
                        /* onClick={(e) => onClickInsertErrorMessage(e)} */
                        disabled // 사용 시 제거 및 onClick 주석 해체
                        : true },
                        React.createElement("span", null, "\uCD94\uAC00")))),
            React.createElement("div", { className: "tbl-list message-list" },
                React.createElement("table", { summary: "\uC5D0\uB7EC\uCF54\uB4DC,\uBA54\uC138\uC9C0,\uBE44\uACE0,\uC5B8\uC5B4,\uC0AD\uC81C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC5D0\uB7EC \uBA54\uC138\uC9C0 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "\uC5D0\uB7EC \uBA54\uC138\uC9C0 \uB9AC\uC2A4\uD2B8"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: { "width": "12%" } }),
                        React.createElement("col", { style: { "width": "" } }),
                        React.createElement("col", { style: { "width": "190px" } }),
                        React.createElement("col", { style: { "width": "6%" } })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC5D0\uB7EC\uCF54\uB4DC"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uBA54\uC138\uC9C0"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC5B8\uC5B4"),
                            React.createElement("th", { scope: "col" }, "\uC0AD\uC81C"))),
                    React.createElement("tbody", null, messageList.map((msg, idx) => (React.createElement("tr", { key: `error_tr_${idx.toString()}` },
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-message", onClick: (e) => onClickViewErrorMessage(e, msg) }, msg.errorCode),
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-message", onClick: (e) => onClickViewErrorMessage(e, msg) }, msg.messageKorean),
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-message", onClick: (e) => onClickViewErrorMessage(e, msg) },
                            React.createElement("ul", { className: "messagelang" },
                                React.createElement("li", { className: (!CUTIL.isnull(msg.messageKorean) && msg.messageKorean.length > 0) ? "on" : "" }, "\uD55C\uAD6D\uC5B4"),
                                React.createElement("li", { className: (!CUTIL.isnull(msg.messageEnglish) && msg.messageEnglish.length > 0) ? "on" : "" }, "English"),
                                React.createElement("li", { className: (!CUTIL.isnull(msg.messageChinese) && msg.messageChinese.length > 0) ? "on" : "" }, "\u4E2D\u6587"))),
                        React.createElement("td", null,
                            React.createElement("button", { type: "button", className: "btn btn-delete-gr js-open", "data-pop": "pop-delete", 
                                /* onClick={(e) => onClickDeleteErrorMessage(e, msg)} */
                                disabled // 사용 시 제거 및 onClick 주석 해체
                                : true },
                                React.createElement("span", { className: "hide" }, "\uD56D\uBAA9 \uC0AD\uC81C"))))))))),
            React.createElement(EhpPagination, { componentName: "ERRORMESSAGELIST", pageInfo: pageInfo, handleFunc: handleCurPage }))));
}
;
export default ErrorMsgList;
function PopupErrorMessageInsert(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props  
    const listReload = props.listReload;
    const setParentListReload = props.setListReload;
    const defaultVal = {
        "errorCode": "",
        "messageKorean": "",
        "messageEnglish": "",
        "messageChinese": "",
    };
    const [errorMessage, setErrorMessage] = useState(defaultVal);
    useEffect(() => {
        setErrorMessage(defaultVal);
    }, [listReload]);
    function callbackSetErrorMessageKor(val) {
        setErrorMessage(Object.assign(Object.assign({}, errorMessage), { messageKorean: val }));
    }
    function callbackSetErrorMessageEng(val) {
        setErrorMessage(Object.assign(Object.assign({}, errorMessage), { messageEnglish: val }));
    }
    function callbackSetErrorMessageCha(val) {
        setErrorMessage(Object.assign(Object.assign({}, errorMessage), { messageChinese: val }));
    }
    const [errorList, setErrorList] = useState([]);
    function onClickDoSaveErrorMessage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const errList = [];
            var doCnt = 0;
            var doneCnt = 0;
            var succCnt = 0;
            let data = null;
            setRecoilIsLoadingBox(true);
            doCnt++;
            data = yield doSaveErrorMessage({
                "errorCode": errorMessage.errorCode,
                "message": errorMessage.messageKorean,
                "language": CONST.STR_APILANG_KOR
            });
            if (data) {
                doneCnt++;
                if (data.codeNum == CONST.API_200) {
                    succCnt++;
                    clog("IN CHECK MSG : KOR INSERT : " + JSON.stringify(data.body));
                }
                else { // api if korean
                    // need error handle
                    data.body.errorList.map((elist) => (errList.push({ "field": elist.field + CONST.STR_APILANG_KOR, "msg": elist.msg })));
                }
                CUTIL.sleep(500);
                doCnt++;
                let edata = yield doSaveErrorMessage({
                    "errorCode": errorMessage.errorCode,
                    "message": errorMessage.messageEnglish,
                    "language": CONST.STR_APILANG_ENG
                });
                if (edata) {
                    doneCnt++;
                    if (edata.codeNum == CONST.API_200) {
                        succCnt++;
                        clog("IN CHECK MSG : ENG INSERT : " + JSON.stringify(data.body));
                    }
                    else { //english
                        edata.body.errorList.map((elist) => (errList.push({ "field": elist.field + CONST.STR_APILANG_ENG, "msg": elist.msg })));
                    }
                    CUTIL.sleep(500);
                    doCnt++;
                    let cdata = yield doSaveErrorMessage({
                        "errorCode": errorMessage.errorCode,
                        "message": errorMessage.messageChinese,
                        "language": CONST.STR_APILANG_CHA
                    });
                    if (cdata) {
                        doneCnt++;
                        if (cdata.codeNum == CONST.API_200) {
                            succCnt++;
                            clog("IN CHECK MSG : CHA INSERT : " + JSON.stringify(data.body));
                        }
                        else { //chinese
                            cdata.body.errorList.map((elist) => (errList.push({ "field": elist.field + CONST.STR_APILANG_CHA, "msg": elist.msg })));
                        }
                    }
                    if (doneCnt === 3) { // KOR/ENG/CHA
                        setErrorList(errList);
                        if (doCnt === succCnt) {
                            setParentListReload(true, 0);
                            CUTIL.jsclose_Popup("pop-message-add");
                        }
                        else {
                        }
                        doneCnt = 0;
                        setRecoilIsLoadingBox(false);
                    }
                }
            }
        });
    }
    function doSaveErrorMessage(cmsg) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "POST",
                "appPath": `/api/v2/message/errormessage`,
                appQuery: {
                    "errorCode": cmsg.errorCode,
                    "message": cmsg.message,
                    "language": cmsg.language
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum !== CONST.API_200) {
                    //alert(`ERROR : ${cmsg.language} : ` + JSON.stringify(data.body.errorList));
                }
            }
            return data;
        });
    }
    function onClickCancel(e) {
        CUTIL.jsclose_Popup("pop-message-add");
        setParentListReload(true, 0);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC5D0\uB7EC\uCF54\uB4DC"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", className: (errorList.filter(err => err.field.includes("errorCode")).length > 0) ? "input-error" : "", value: errorMessage.errorCode, onChange: (e) => setErrorMessage(Object.assign(Object.assign({}, errorMessage), { errorCode: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter((err, idx) => err.field.includes("errorCode") && (idx === 0)).map((err) => err.msg))))),
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uBA54\uC138\uC9C0")),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uD55C\uAD6D\uC5B4"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "messageKorean")).length > 0) ? "input-error" : "", value: errorMessage.messageKorean, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetErrorMessageKor), onChange: (e) => setErrorMessage(Object.assign(Object.assign({}, errorMessage), { messageKorean: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "messageKorean")).map((err) => err.msg)))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC601\uBB38 (English)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "messageEnglish")).length > 0) ? "input-error" : "", value: errorMessage.messageEnglish, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetErrorMessageEng), onChange: (e) => setErrorMessage(Object.assign(Object.assign({}, errorMessage), { messageEnglish: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "messageEnglish")).map((err) => err.msg)))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC911\uBB38 (\u4E2D\u6587)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "messageChinese")).length > 0) ? "input-error" : "", value: errorMessage.messageChinese, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetErrorMessageCha), onChange: (e) => setErrorMessage(Object.assign(Object.assign({}, errorMessage), { messageChinese: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "messageChinese")).map((err) => err.msg)))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-close", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button", onClick: (e) => onClickDoSaveErrorMessage(e) },
                React.createElement("span", null, "\uC644\uB8CC")))));
}
function PopupErrorMessageView(props) {
    const setParentPopWin = props.setPopWin;
    const [errorMessage, setErrorMessage] = useState(null);
    //const onClickUpdateCheckMessage = props.onClickUpdateCheckMessage;
    const listReload = props.listReload;
    const setParentListReload = props.setListReload;
    //
    const [updateCount, setUpdateCount] = useState(0);
    // 메시지 항목이 변경될때마다..초기화
    useEffect(() => {
        setErrorMessage(props.errorMessage);
        setUpdateCount(0);
    }, [props.errorMessage]);
    function onClickUpdateErrorMessage(e, message) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-message-edit");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "557");
        CUTIL.jsclose_Popup("pop-message");
        setParentPopWin("pop-message-edit", React.createElement(PopupErrorMessageUpdate, { htmlHeader: React.createElement("h1", null, "\uC5D0\uB7EC \uBA54\uC138\uC9C0"), errorMessage: message, listReload: listReload, setListReload: props.setListReload, updateCount: updateCount, setUpdateCount: setUpdateCount, setPopWin: props.setPopWin }));
        CUTIL.jsopen_Popup(e);
    }
    function onClickCancel(e) {
        //setParentListReload(true);
        CUTIL.jsclose_Popup("pop-message");
        setParentPopWin("pop-message", null);
    }
    return (React.createElement(React.Fragment, null,
        (errorMessage) && React.createElement("div", { className: "popup__body" },
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC5D0\uB7EC\uCF54\uB4DC"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", value: CUTIL.isnull(errorMessage.errorCode) ? "" : errorMessage.errorCode, disabled: true })))),
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uBA54\uC138\uC9C0")),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uD55C\uAD6D\uC5B4"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { value: CUTIL.isnull(errorMessage.messageKorean) ? "" : errorMessage.messageKorean, readOnly: true }))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC601\uBB38 (English)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { value: CUTIL.isnull(errorMessage.messageEnglish) ? "" : errorMessage.messageEnglish, readOnly: true }))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC911\uBB38 (\u4E2D\u6587)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { value: CUTIL.isnull(errorMessage.messageChinese) ? "" : errorMessage.messageChinese, readOnly: true }))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-open btn-close", "data-pop": "pop-message-edit", onClick: (e) => onClickUpdateErrorMessage(e, errorMessage) },
                React.createElement("span", null, "\uC218\uC815")),
            React.createElement("button", { type: "button", className: "", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, "\uD655\uC778")))));
}
function PopupErrorMessageUpdate(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props  
    const listReload = props.listReload;
    const setParentListReload = props.setListReload;
    //
    const updateCount = props.updateCount;
    const setParentUpdateCount = props.setUpdateCount;
    //
    const setParentPopWin = props.setPopWin;
    const [errorMessage, setErrorMessage] = useState(null);
    clog("IN UPDATE : " + listReload);
    useEffect(() => {
        setErrorMessage(props.errorMessage);
    }, [updateCount, props.errorMessage]);
    function callbackSetErrorMessageKor(val) {
        setErrorMessage(Object.assign(Object.assign({}, errorMessage), { messageKorean: val }));
    }
    function callbackSetErrorMessageEng(val) {
        setErrorMessage(Object.assign(Object.assign({}, errorMessage), { messageEnglish: val }));
    }
    function callbackSetErrorMessageCha(val) {
        setErrorMessage(Object.assign(Object.assign({}, errorMessage), { messageChinese: val }));
    }
    const [errorList, setErrorList] = useState([]);
    function onClickDoUpdateErrorMessage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const errList = [];
            var doCnt = 0;
            var doneCnt = 0;
            var succCnt = 0;
            let data = null;
            setRecoilIsLoadingBox(true);
            doCnt++;
            data = yield doUpdateErrorMessage({
                "errorCode": errorMessage.errorCode,
                "message": errorMessage.messageKorean,
                "language": CONST.STR_APILANG_KOR
            });
            if (data) {
                doneCnt++;
                if (data.codeNum == CONST.API_200) {
                    succCnt++;
                    clog("IN HTTP MSG : KOR UPDATE : " + JSON.stringify(data.body));
                }
                else { // api if korean
                    // need error handle
                    data.body.errorList.map((elist) => (errList.push({ "field": elist.field + CONST.STR_APILANG_KOR, "msg": elist.msg })));
                }
                CUTIL.sleep(500);
                doCnt++;
                let edata = yield doUpdateErrorMessage({
                    "errorCode": errorMessage.errorCode,
                    "message": errorMessage.messageEnglish,
                    "language": CONST.STR_APILANG_ENG
                });
                if (edata) {
                    doneCnt++;
                    if (edata.codeNum == CONST.API_200) {
                        succCnt++;
                        clog("IN HTTP MSG : ENG UPDATE : " + JSON.stringify(data.body));
                    }
                    else { //english
                        edata.body.errorList.map((elist) => (errList.push({ "field": elist.field + CONST.STR_APILANG_ENG, "msg": elist.msg })));
                    }
                    CUTIL.sleep(500);
                    doCnt++;
                    let cdata = yield doUpdateErrorMessage({
                        "errorCode": errorMessage.errorCode,
                        "message": errorMessage.messageChinese,
                        "language": CONST.STR_APILANG_CHA
                    });
                    if (cdata) {
                        doneCnt++;
                        if (cdata.codeNum == CONST.API_200) {
                            succCnt++;
                            clog("IN HTTP MSG : CHA UPDATE : " + JSON.stringify(data.body));
                        }
                        else { //chinese
                            cdata.body.errorList.map((elist) => (errList.push({ "field": elist.field + CONST.STR_APILANG_CHA, "msg": elist.msg })));
                        }
                    }
                    if (doneCnt === 3) { // KOR/ENG/CHA
                        setErrorList(errList);
                        setParentListReload(true, -1);
                        setParentPopWin("pop-message", React.createElement(PopupErrorMessageView, { htmlHeader: React.createElement("h1", null, "\uC5D0\uB7EC \uBA54\uC138\uC9C0"), errorMessage: errorMessage, listReload: listReload, setListReload: props.setListReload, setPopWin: props.setPopWin }));
                        if (doCnt === succCnt) {
                            CUTIL.jsclose_Popup("pop-message-edit");
                            var popupVal = e.target.getAttribute("data-pop");
                            if (CUTIL.isnull(popupVal))
                                e.target.setAttribute("data-pop", "pop-message");
                            CUTIL.jsopen_Popup(e);
                        }
                        else {
                        }
                        doneCnt = 0;
                        setRecoilIsLoadingBox(false);
                    }
                }
            }
        });
    }
    function doUpdateErrorMessage(cmsg) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "PUT",
                "appPath": `/api/v2/message/errormessage`,
                appQuery: {
                    "errorCode": cmsg.errorCode,
                    "message": cmsg.message,
                    "language": cmsg.language
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum !== CONST.API_200) {
                    //alert(`ERROR : ${cmsg.language} : ` + JSON.stringify(data.body.errorList));
                }
            }
            return data;
        });
    }
    function onClickCancel(e) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-message");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "557");
        CUTIL.jsclose_Popup("pop-message-edit");
        setParentPopWin("pop-message-edit", null);
        CUTIL.jsopen_Popup(e);
        setErrorList([]);
        setParentUpdateCount(updateCount + 1);
    }
    return (React.createElement(React.Fragment, null,
        (errorMessage) && React.createElement("div", { className: "popup__body" },
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC5D0\uB7EC\uCF54\uB4DC"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", className: (errorList.filter(err => err.field.includes("errorCode")).length > 0) ? "input-error" : "", value: errorMessage.errorCode, 
                            // onChange={(e) => setErrorMessage({ ...errorMessage, errorCode: e.target.value })}
                            disabled: true }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter((err, idx) => err.field.includes("errorCode") && (idx === 0)).map((err) => err.msg))))),
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uBA54\uC138\uC9C0")),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uD55C\uAD6D\uC5B4"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "messageKorean")).length > 0) ? "input-error" : "", value: CUTIL.isnull(errorMessage.messageKorean) ? "" : errorMessage.messageKorean, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetErrorMessageKor), onChange: (e) => setErrorMessage(Object.assign(Object.assign({}, errorMessage), { messageKorean: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "messageKorean")).map((err) => err.msg)))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC601\uBB38 (English)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "messageEnglish")).length > 0) ? "input-error" : "", value: CUTIL.isnull(errorMessage.messageEnglish) ? "" : errorMessage.messageEnglish, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetErrorMessageEng), onChange: (e) => setErrorMessage(Object.assign(Object.assign({}, errorMessage), { messageEnglish: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "messageEnglish")).map((err) => err.msg)))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC911\uBB38 (\u4E2D\u6587)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "messageChinese")).length > 0) ? "input-error" : "", value: CUTIL.isnull(errorMessage.messageChinese) ? "" : errorMessage.messageChinese, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetErrorMessageCha), onChange: (e) => setErrorMessage(Object.assign(Object.assign({}, errorMessage), { messageChinese: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "messageChinese")).map((err) => err.msg)))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-close btn-close", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button", onClick: (e) => onClickDoUpdateErrorMessage(e) },
                React.createElement("span", null, "\uC644\uB8CC")))));
}
function PopupErrorMessageDelete(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props  
    const setParentListReload = props.setListReload;
    const [errorMessage, setErrorMessage] = useState(null);
    useEffect(() => {
        setErrorMessage(props.errorMessage);
    }, [props.errorMessage]);
    function onClickDoDeleteErrorMessage(e, message) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            setRecoilIsLoadingBox(true);
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "DELETE",
                "appPath": `/api/v2/message/errormessage`,
                appQuery: {
                    "errorCode": message.errorCode,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                setRecoilIsLoadingBox(false);
                if (data.codeNum == CONST.API_200) {
                    clog("IN COMPANY : onClickDoSaveCompany : " + JSON.stringify(data.body));
                    CUTIL.jsclose_Popup("pop-delete");
                    setParentListReload(true, 0);
                }
                else { // api if
                    // need error handle
                    alert("ERROR : " + JSON.stringify(data.body.errorList));
                }
            }
        });
    }
    function onClickCancel(e) {
        CUTIL.jsclose_Popup("pop-delete");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("p", null, "\uD574\uB2F9 \uC5D0\uB7EC\uBA54\uC138\uC9C0\uB97C \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?")),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-close btn-close", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button", className: "", onClick: (e) => onClickDoDeleteErrorMessage(e, errorMessage) },
                React.createElement("span", null, "\uD655\uC778")))));
}
